import type { Alert } from '@/api/alert/types/alert';
import { useUser } from '@/api/user/queries/use-user';
import { resolveAlertNavigationPath } from '@/services/alert-navigation';
import { useIonRouter } from '@ionic/vue';

export const useAlertClick = (isPreviewClick?: boolean, isPushOrigin?: boolean) => {
  const router = useIonRouter();
  const { data: user } = useUser();
  return (alert: Alert) => {
    const path = resolveAlertNavigationPath(alert, {
      currentUserId: user.value?.id,
      isPreviewClick,
      isPushOrigin,
    });
    if (path) {
      router.push(path);
    }
  };
};

/**
 * Only for taps that originate in a system notification — never for the in-app
 * notifications list or socket toasts, which do have a real screen behind them.
 */
export const usePushAlertClick = () => useAlertClick(false, true);
